import * as React from "react"

const Atmark = ({size}) => (
    <svg
        data-name="layer 2"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 11.051 13.652"
    >
        <path
            d="m8.25 4.36-.686 2.337c-.253.875-.408 1.43-.462 1.664s-.082.422-.082.563a.435.435 0 0 0 .439.445c.285 0 .628-.142 1.028-.428s.743-.748 1.029-1.388.427-1.309.427-2.004c0-.668-.16-1.285-.483-1.852s-.777-1-1.365-1.303-1.238-.455-1.949-.455c-.902 0-1.74.24-2.513.718S2.247 3.824 1.796 4.723s-.677 1.832-.677 2.8c0 .899.198 1.715.595 2.45s.954 1.29 1.673 1.667 1.492.565 2.32.565c1.027 0 1.956-.275 2.786-.826s1.472-1.356 1.925-2.414h.34c-.352 1.07-.99 1.937-1.916 2.601s-1.98.997-3.164.997c-.93 0-1.793-.22-2.59-.66s-1.416-1.062-1.858-1.869S.568 8.34.568 7.371c0-1.031.243-1.993.727-2.886s1.163-1.59 2.036-2.091 1.8-.753 2.78-.753c.809 0 1.538.167 2.189.5s1.145.823 1.485 1.465.51 1.326.51 2.048c0 .715-.16 1.423-.478 2.124S9.094 8.99 8.602 9.311s-1.006.48-1.541.48c-.297 0-.521-.07-.671-.21s-.226-.339-.226-.593c0-.218.035-.506.106-.861-.579.7-1.041 1.152-1.39 1.36s-.653.31-.92.31c-.276 0-.523-.124-.737-.372s-.323-.58-.323-.993c0-.567.185-1.202.554-1.905s.858-1.275 1.468-1.716c.45-.325.851-.487 1.207-.487.262 0 .48.068.653.202s.292.337.355.607l.193-.645.92-.129Zm-2.057.24c-.293 0-.59.154-.89.463-.442.453-.819 1.064-1.131 1.833-.23.563-.346 1.016-.346 1.36 0 .246.07.446.208.6s.294.232.466.232c.227 0 .465-.086.715-.258s.512-.436.785-.794.473-.716.598-1.075c.218-.621.328-1.127.328-1.518 0-.257-.072-.463-.214-.615S6.396 4.6 6.193 4.6Z"
            style={{
                fill: "#231815",
            }}
            data-name="layer 1"
        />
    </svg>
)

export default Atmark
